// NOSONAR
export const LOGIN = "login";
export const NOTIFICATIONS = "me/notifications";
export const NOTIFICATIONS_CATEGORIES = "meta/notifications/categories";
export const META_TRANSLATIONS = "meta/translations";
export const DOWNLOAD_TRANSLATION = (languageCode) => `meta/translations/${languageCode}/download`;
export const REGISTER = "register";
export const REGISTER_VERIFY_EMAIL = "register/verify";
export const ADDRESS = "addresses";
export const VERIFY_EMAIL = "reset";
export const USER_PROFILE = "me";
export const GET_STATES = "meta/locations/states";
export const GET_TIMEZONES = "meta/dates/timezones";
export const FORGOT_PASSWORD = "reset/verify"; // NOSONAR - API endpoint, not a password
export const LOGOUT = "logout";
export const TUTORIAL = "training";
export const PROFILE = "me/profile/image";
export const TEMPLATES = "templates";
export const CUSTOMER_OBJECT = "objects";
export const GET_COUNTRIES = "meta/locations/countries";
export const GET_PROFILE = "me";
export const ERROR_MESSAGE = "meta/errors";
export const FILES = "files";
export const FILE_UPLOAD = (fileId) => `files/${fileId}/upload`;
export const FILE_DELETE = (fileId) => `files/${fileId}`;
export const FILE_INFO = (fileId) => `files/${fileId}`;
export const FILE_DOWNLOAD = (fileId) => `files/${fileId}/download`;
export const USER_STATISTICS = "files/statistics";
export const CONTACT_PREFERENCES = "me/preferences/contact";
export const UPDATE_ADDRESS = (id) => `addresses/${id}`;
export const USER_ACCOUNT_STATUS = "me/account/status";
export const SUBSCRIPTION_PRICING = "subscriptions/pricing";
export const SUBSCRIPTION_PLAN = "subscriptions/plans";
export const USER_SUBSCRIPTIONS = "subscriptions/residualvalue";
export const GET_ALL_DOCUMENT = "documents/templates";
export const GET_DOCUMENT = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}`;
export const GENERATE_DOCUMENT = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}`;
export const RESET_DOCUMENT = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}`;
export const DOWNLOAD_DOCUMENT = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}/download`;
export const GET_DOCUMENT_HISTORY = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}/history`;
export const DOCUMENT_LEGALIZE = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}/legalize`;
export const GET_LEGALIZE_DOCUMENT = (documentTemplateSlug) =>
  `me/documents/${documentTemplateSlug}/legalize/download`;
export const SUBSCRIPTION_CODE = "subscriptions/code";
export const LINK_FILE_TO_FIELD = (objectId, fieldId, fileId) =>
  `objects/${objectId}/fields/${fieldId}/file/${fileId}`;
export const LINK_FILE_TO_OBJECT = (objectId, fileId) => 
  `objects/${objectId}/files/${fileId}`;
export const UNLINK_FILE_FROM_OBJECT = (objectId, fileId) => 
  `objects/${objectId}/files/${fileId}`;
export const GET_OBJECT_FILES = (objectId) => 
  `objects/${objectId}/files`;
export const UPDATE_CUSTOMER_OBJECT_FIELD = (objectId, fieldId) =>
  `objects/${objectId}/fields/${fieldId}`;
export const ROLE_INVITATIONS = "me/invitations";
export const ROLE_INVITATIONS_RESPOND = "invitations/response";
export const AGENTS = "me/agents";
export const SAVE_HEALTH_POA = "me/poas/health";
export const GET_HEALTH_POA = "me/poas/health";
export const UPDATE_HEALTH_POA = (poaId) => `me/poas/health/${poaId}`;
export const LINK_POA = (poaType, poaId) => `me/poas/${poaType}/${poaId}/links`;
export const SAVE_FINANCIAL_POA = "me/poas/financial";
export const UPDATE_FINANCIAL_POA = (FpoaId) => `me/poas/financial/${FpoaId}`;
export const ENCRYPTION = "me/encryption/status";
export const ENCRYPTION_ROTATE = "me/encryption/rotate";
export const ENCRYPTION_DATA = "me/encryption/data";
export const ENCRYPTION_STATISTICS = "me/encryption/data/statistics";
export const SHARE_LINK = (shareType) => `me/objects/${shareType}/share/link`;
export const GET_FOOTER = "me/tasks";
export const GET_WISHES = "wishes";
export const CASH_BEQUEST = (objectId) => `wishes/bequests/cash/${objectId}`;
export const WISHES_DISINHERIT = "wishes/disinherits";
export const WISHES_DEPENDENTS_TRUST = "wishes/dependents/trust/age";
export const WISHES_PET_TRUST = "/wishes/trusts/pets";
export const TOTAL_CASH_BEQUEST = "wishes/bequests/cash";
export const GET_MODULE = "modules";
export const GET_MODULE_SECTION = (slug) => `modules/${slug}`;
export const PREFERENCES = "me/preferences";
export const HEALTH_SUPPORT = "me/health/support";
export const WISHES_EOL_ROLE = "wishes/eol/roles";
export const ASSET_BEQUEST_RECIPIENT = (assetId, toObjectId) =>
  `wishes/bequests/assets/${assetId}/${toObjectId}`;
export const REFRESH_TOKEN = "/me/refresh";
export const DIGITAL_VAULT_CATEGORIES = "vault/categories";
export const PAYMENT_METHOD = "me/subscriptions/payments/methods";
export const SUBSCRIPTION = "me/subscriptions";
export const REGISTER_USER_INCAPACITATION = "users/report/incap";
export const GET_AGENT_DASHBOARD = (agentID) =>
  `me/agents/${agentID}/dashboard`;
export const REGISTER_DISPUTE = "me/report/status";
export const AGENT_REGISTER_INCAPACITATION = (agentID) =>
  `me/agents/${agentID}/dashboard/report`;
export const AGENT_REPUDIATE = (agentID) => `me/agents/${agentID}/repudiate`;
export const AGENT_ENCRYPTION = (agentID) => `me/agents/${agentID}/encryption`;
export const AGENT_RELEASE_KEY = (agentID) => `me/agents/${agentID}/dashboard/key`;
export const AGENT_RELEASE_ITEM = (agentID) =>
  `me/agents/${agentID}/dashboard/release/objects`;
export const GET_AGENT_RELEASE_ITEM = (agentID) =>
  `me/agents/${agentID}/dashboard/objects`;
export const AGENT_RELEASE_STORY = (agentID) =>
  `me/agents/${agentID}/dashboard/release/stories`;
export const GET_AGENT_RELEASE_STORY = (agentID) =>
  `me/agents/${agentID}/dashboard/stories`;
export const AGENT_RELEASE_MESSAGE = (agentID) =>
  `me/agents/${agentID}/dashboard/release/messages`;
export const GET_AGENT_RELEASE_MESSAGE = (agentID) =>
  `me/agents/${agentID}/dashboard/messages`;
export const AGENT_GET_DOCUMENT = (agentID) =>
  `me/agents/${agentID}/dashboard/documents`;
export const AGENT_DOWNLOAD_DOCUMENT = (agentID, documentTemplateSlug) =>
  `me/agents/${agentID}/dashboard/documents/${documentTemplateSlug}/download`;
export const AGENT_DEATH_CERTIFICATE_UPLOAD = (agentID) =>
  `me/agents/${agentID}/dashboard/report/upload`;
export const THUMBNAIL_UPLOAD = (objectID) => `objects/${objectID}/thumbnail`;
export const GET_THUMBNAIL = (objectID) => `objects/${objectID}/thumbnail`;
export const GET_SUBSCRIPTION = (subscriptionId) =>
  `me/subscriptions/${subscriptionId}`;
export const AGENT_DIGITAL_VAULT = (agentID) =>
  `me/agents/${agentID}/dashboard/objects`;
export const AGENT_PROFILE = (agentID) => `users/${agentID}/profile`;
export const AGENT_IMAGE = (agentID) => `users/${agentID}/profile/image`;
export const GET_AGENT_DEATH_CERTIFICATE = (agentID) =>
  `me/agents/${agentID}/dashboard/report/download`;
